import MessageQueueStore from './MessageQueue.store';

export const messageQueueStore = new MessageQueueStore();
